import Env from '../base/env'
import Waypoint from '../vendor/waypoints'
import Channels from '../base/channels'
import 'babel-polyfill'

class FlowWaypoints
{
    constructor(view)
    {
        if(typeof view == 'undefined') return;
        this.view = view;
        this.instances = []
        this.timerOut = false
        this.appear()
        this.introduction()
        this.order()
        this.whiteOn()
        this.events()
        this.next()
    }

    appear()
    {
        const $items = this.view.querySelectorAll('.jsWaypoint--appearReveal')
        for(let i = 0; i<$items.length;i++)
        {
            const $ref = $items[i]
            const offset = (typeof $ref.getAttribute('data-offset') != "undefined")?$ref.getAttribute('data-offset'):"0%"

            const instance = new Waypoint({
                element: $ref,
                handler: (_direction)=> {
                    $ref.classList.add('is--shown')
                },
                offset: offset
            });
            this.instances.push(instance);
        }
    }

    destroy()
    {
        Env.$html.classList.remove('skin--isWhite')
        Env.$html.classList.remove('skin--isDark')

        for(let i = 0; i < this.instances.length; i++) {
            const instance = this.instances[i]
            instance.destroy()
        }
        this.instances = []
    }

    events()
    {
        Channels.on('window::smartresize',() =>
        {
            for(let i = 0; i < this.instances.length; i++) {
                const instance = this.instances[i]
                instance.context.refresh()
            }
        })
    }

    introduction()
    {
        const $waypoint = this.view.querySelector('.jsWaypoint--appearIntroduction')
        if($waypoint !== null) {
            const instanceFixed = new Waypoint({
                element: $waypoint,
                handler: (direction)=> {
                    if(direction === 'down') {
                        if($waypoint.classList.contains('is--fixed') === false) {
                            $waypoint.classList.add('is--fixed')
                        }
                    } else {
                        if($waypoint.classList.contains('is--fixed') === true) {
                            $waypoint.classList.remove('is--fixed')
                        }
                    }
                },
                offset: '0%'
            });
            this.instances.push(instanceFixed);

            const instanceShown = new Waypoint({
                element: $waypoint,
                handler: (direction)=> {
                    if(direction === 'down') {
                        $waypoint.classList.add('is--shown')
                    }
                },
                offset: '32%'
            });
            this.instances.push(instanceShown);

            const instanceExit = new Waypoint({
                element: $waypoint,
                handler: (direction)=> {
                    if(direction === 'down') {
                        if(Env.$html.classList.contains('introduction--isHidden') === false) {
                            Env.$html.classList.add('introduction--isHidden')
                        }
                    } else {
                        if(Env.$html.classList.contains('introduction--isHidden') === true) {
                            Env.$html.classList.remove('introduction--isHidden')
                        }
                    }
                },
                offset: '-70%'
            });
            this.instances.push(instanceExit);
        }
    }

    next()
    {
        const $waypoint = this.view.querySelector('.jsWaypoint--next')
        const $next = this.view.querySelector('.single-next')
        if($waypoint !== null && $next !== null) {
            const instance = new Waypoint({
                element: $waypoint,
                handler: (_direction)=> {
                    $next.classList.add('is--shown')
                },
                offset: '150%'
            });
            this.instances.push(instance);
        }
    }

    order()
    {
        const $waypoint = this.view.querySelector('.jsWaypoint--zIndexOrder')
        if($waypoint !== null) {
            const instance = new Waypoint({
                element: $waypoint,
                handler: (direction)=> {
                    if(direction === 'down') {
                        if(Env.$html.classList.contains('cover--isHidden') === false) {
                            Env.$html.classList.add('cover--isHidden')
                        }
                    } else {
                        if(Env.$html.classList.contains('cover--isHidden') === true) {
                            Env.$html.classList.remove('cover--isHidden')
                        }
                    }
                },
                offset: '-5%'
            });
            this.instances.push(instance);
        }
    }

    whiteOn()
    {
        const $items = this.view.querySelectorAll('.jsWaypoint--whiteSkinOn')
        for(let i = 0; i < $items.length ; i++) {
            const $ref = $items[i]
            const getHeight = $ref.getBoundingClientRect().height * -1
            const viewport = Env.framework.toolbox.getViewport()
            const gapViewportToRef = (viewport.height - (getHeight * -1)) - 60

            // Ui Top In
            const instanceTopIn = new Waypoint({
                element: $ref,
                handler: function(_direction) {
                    if(_direction == 'down')
                    {
                        Env.$html.classList.add('skin--isWhite')
                    }
                    else
                    {
                        Env.$html.classList.remove('skin--isWhite')
                    }
                },
                offset: '0%'
            });
            this.instances.push(instanceTopIn);
            // Ui Bottom In
            const instanceBottomIn = new Waypoint({
                element: $ref,
                handler: function(_direction) {
                    if(_direction == 'down')
                    {
                        Env.$html.classList.add('skin--bottomIsWhite')
                    }
                    else
                    {
                        Env.$html.classList.remove('skin--bottomIsWhite')
                    }
                },
                offset: viewport.height - 100
            });
            this.instances.push(instanceBottomIn);

            // UI Top Out
            const instanceTopOut = new Waypoint({
                element: $ref,
                handler: function(_direction) {
                    if(_direction == 'up')
                    {
                        setTimeout(()=>
                        {
                            Env.$html.classList.add('skin--isWhite')
                        },24)

                    }
                    else
                    {
                        Env.$html.classList.remove('skin--isWhite')
                    }

                },
                offset: getHeight
            });
            this.instances.push(instanceTopOut);

            // UI Bottom Out
            const instanceBottomOut = new Waypoint({
                element: $ref,
                handler: function(_direction) {
                    if(_direction == 'up')
                    {
                        setTimeout(()=>
                        {
                            Env.$html.classList.add('skin--bottomIsWhite')
                        },24)

                    }
                    else
                    {
                        Env.$html.classList.remove('skin--bottomIsWhite')
                    }

                },
                offset: gapViewportToRef
            });
            this.instances.push(instanceBottomOut);
        }
    }

}

export default FlowWaypoints;